import { useTranslation } from "react-i18next";

import { usePublicKeyQuery } from "@/api/query-hooks";
import { ErrorState, LoadingState } from "@/components/layout/route-states";

export function SettingsPage() {
  const { t } = useTranslation("common");
  const publicKey = usePublicKeyQuery();

  if (publicKey.isLoading) {
    return <LoadingState />;
  }
  if (publicKey.isError) {
    return <ErrorState title={t("states.error")} detail={publicKey.error.message} onRetry={() => void publicKey.refetch()} />;
  }

  return (
    <div className="grid gap-4">
      <div>
        <h2 className="text-lg font-semibold">{t("nav.settings")}</h2>
        <p className="mt-1 text-sm text-muted-foreground">Runtime metadata exposed by platform-api.</p>
      </div>
      <section className="rounded-md border bg-panel p-4">
        <div className="grid gap-3 md:grid-cols-[180px_1fr]">
          <div className="text-sm text-muted-foreground">Kind</div>
          <div className="font-mono text-sm">{publicKey.data?.kind}</div>
          <div className="text-sm text-muted-foreground">Version</div>
          <div className="font-mono text-sm">{publicKey.data?.version}</div>
          <div className="text-sm text-muted-foreground">Public key</div>
          <div className="break-all font-mono text-xs">{publicKey.data?.publicKey}</div>
        </div>
      </section>
    </div>
  );
}
